import React from 'react';
import { Text } from '@chakra-ui/react';

export const Title = React.memo(() => {
  return (
    <Text
      fontSize={{ base: 17, sm: 18, md: 20, lg: 22 }}
      color="orange.700"
      fontWeight="bold"
    >
      推廣期間，凡自家CLUB會員於全線分店：
    </Text>
  );
});
